import {
  CustomMonthsPeriodState,
  UpdateMainFiltersTaPayload,
} from '../../reducers/main-filter-trading/MainFiltersTaReducer';
import { MainFiltersTaActionType } from '../Type';
import { BaseTimePeriod } from '@services/FiltersTypes';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { RelativePeriod } from '@components/comparison-period-selector/Types';

export const updateMainFiltersTA = (payload: UpdateMainFiltersTaPayload): MainFiltersTradingAssistantAction => {
  return {
    type: MainFiltersTaActionType.UpdateMainFiltersTA,
    payload,
  };
};

export const updateMainFiltersTAPeriod = (payload: BaseTimePeriod): MainFiltersTradingAssistantAction => {
  return {
    type: MainFiltersTaActionType.UpdateMFTAPeriod,
    payload,
  };
};

export const updateMainFiltersTAPeriodicity = (payload: Periodicity): MainFiltersTradingAssistantAction => {
  return {
    type: MainFiltersTaActionType.UpdateMFTAPeriodicity,
    payload,
  };
};

export const updateMainFiltersTAComparisonPeriod = (
  payload: RelativePeriod | BaseTimePeriod,
): MainFiltersTradingAssistantAction => {
  return {
    type: MainFiltersTaActionType.UpdateMFTAComparisonPeriod,
    payload,
  };
};

export const updateMainFiltersTACustomMonthsPeriodState = (
  payload: CustomMonthsPeriodState,
): MainFiltersTradingAssistantAction => {
  return {
    type: MainFiltersTaActionType.UpdateMFTACustomMonthsPeriodState,
    payload,
  };
};

export type MainFiltersTradingAssistantAction =
  | UpdateMainFiltersTaAction
  | UpdateMFTAPeriod
  | UpdateMFTAPeriodicity
  | UpdateMFTAComparisonPeriod
  | UpdateMFTACustomMonthsPeriodState;

type UpdateMainFiltersTaAction = ActionType<MainFiltersTaActionType.UpdateMainFiltersTA> & {
  payload: UpdateMainFiltersTaPayload;
};

type UpdateMFTAPeriod = ActionType<MainFiltersTaActionType.UpdateMFTAPeriod> & {
  payload: BaseTimePeriod;
};

type UpdateMFTAPeriodicity = ActionType<MainFiltersTaActionType.UpdateMFTAPeriodicity> & {
  payload: Periodicity;
};

type UpdateMFTAComparisonPeriod = ActionType<MainFiltersTaActionType.UpdateMFTAComparisonPeriod> & {
  payload: RelativePeriod | BaseTimePeriod;
};

type ActionType<MainFiltersTaActionType> = {
  type: MainFiltersTaActionType;
};

type UpdateMFTACustomMonthsPeriodState = ActionType<MainFiltersTaActionType.UpdateMFTACustomMonthsPeriodState> & {
  payload: CustomMonthsPeriodState;
};
